module.exports = __webpack_public_path__ + "img/1.b6fd3bb4.png";